import { nodeContentRenderer } from './node-content';
import { treeNodeRenderer } from '../tree-node';
export function createCustomTheme(lineBlock, show_scaffolds, RenderItem, RenderGroupItem) {
    return {
        nodeContentRenderer: (props) => nodeContentRenderer({ ...props, RenderItem, RenderGroupItem }),
        treeNodeRenderer: (props) => treeNodeRenderer({ ...props, lineBlock, show_scaffolds }),
        scaffoldBlockPxWidth: 15,
        style: null,
        placeholderRenderer: null,
        slideRegionSize: 10,
        innerStyle: null,
    };
}
